import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { TOASTER_VARIANT } from '../../components/toast/constants';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../constants/constants';
import { addNotifications } from '../toaster/ToasterPortalSlice';
import { componentKey, setExportFile, setFormList, setIsNewUser, setIsNewUserLoading, setLoadingState, setReportData, setSelectedForm, setSelectedStatus, setSelectedYear, setStatusList, setTotalReport, setUrgentIssues, setYearList } from './HomeSectionSlice';
import DashboardDataService from '../../../services/DashboardDataService';
import SubmitFormsDataService from '../../../services/SubmitFormsDataService';
import { FEATURE_FLAG } from '../../featureFlags';

export const { getFilterData, getReportData, createPDF, downloadPDF, checkIsNewUser, getDashboardExcelData, getAccountStatus } = {
    getFilterData: (payload) => {
        return {
            type: "DASHBOARD/GET_FILTER_DATA",
            payload: payload
        }
    },
    getReportData: (payload) => {
        return {
            type: "DASHBOARD/GET_REPORT_DATA",
            payload: payload
        }
    },
    createPDF: (payload) => {
        return {
            type: "DASHBOARD/CREATE_PDF",
            payload: payload
        }
    },
    downloadPDF: (payload) => {
        return {
            type: "DASHBOARD/DOWNLOAD_PDF",
            payload: payload
        }
    },
    checkIsNewUser: (payload) => {
        return {
            type: "DASHBOARD/GET_FORM_COUNT",
            payload: payload
        }
    },
    getDashboardExcelData: (payload) =>{
        return {
            type: "DASHBOARD/GET_EXCEL_DATA",
            payload: payload
        }   
    },
    getAccountStatus: (payload) =>{
        return {
            type: "DASHBOARD/GET_ACCOUNT_STATUS",
            payload: payload
        }   
    }
}


function* getFilterDataAsync(action) {
    try {
        const {currentTaxyear} = action.payload
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING, message: "Fetching filter details..." }));
        const response = yield DashboardDataService.getListDetails();
    
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            const yearsList = response?.data?.Data?.YearList ?? {};
            const years = [];
            Object.keys(yearsList).forEach(year => years.push({ label: year, value: year }))

            yield put(setYearList(years))

            const selectedYear = years.length > 0 ? ((currentTaxyear && years.find(year => year.value == currentTaxyear)) || (years[years.length - 1])) : { label: '', value: '' };
            yield put(setSelectedYear(selectedYear))

            const forms = [{ label: 'All Form Types', value: 'All Form Types' }, ...response.data.Data.FormList.map(form => ({ label: form.FormName1, value: form.FormId }))]
            yield put(setFormList(forms))
            yield put(setSelectedForm(forms.length > 0  ? forms[0] : {label: '', value: ''}))

            const statusList = response.data.Data.StatusList;
            const status = [];
            Object.keys(statusList).forEach(key => status.push({ label: key, value: statusList[key] === "" ? [] : statusList[key].split(",").map(id => parseInt(id)) }))

            yield put(setStatusList(status))
            yield put(setSelectedStatus(status.length > 0  ? status[0] : {label: '', value: ''}))

        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getReportDataAsync(action) {
    const {params} = action.payload;
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Fetching filter details..." }));

        const response = yield DashboardDataService.getSubmissionList(params);
        
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setReportData(response.data.Data.Data))
            yield put(setTotalReport(response.data.Data.Total))

        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* createPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Creating PDF..." }));
        const response = yield SubmitFormsDataService.createZipForDownloadAll(action.payload);
        
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield call(downloadPDFAsync, { payload: { payerName: response.data.Data.EncryptedPayerName, FormName: response.data.Data.FormName } })
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* downloadPDFAsync(action) {
    try {
        const { payerName, FormName } = action.payload;
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Downloading PDF..." }));
        const response = yield SubmitFormsDataService.downloadMultiplePDF(payerName, FormName);
    
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setExportFile(response.data.Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* checkIsNewUserAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
        const response = yield DashboardDataService.CheckIfDataPresent();

        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            const { HasForm, HasPayer, HasRecipient } = response.data.Data;

            if (!HasForm && !HasPayer && !HasRecipient) {
                yield put(setIsNewUser(true))
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }))
        yield put(setIsNewUserLoading(false))
    }
}

function* downloadDashboardExcelAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
        const response = yield DashboardDataService.downloadDashboardExcelData();
    
        if (response.data) {
            if (response.data.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                yield put(setExportFile(response.data.Data))
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* getAccountStatusAsync(action) {
    try {
        const { accountStatusCancelToken } = action.payload;
        const response = yield DashboardDataService.getAccountStatus(accountStatusCancelToken);
        if (response.data) {
            if (response.data.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                yield put(setUrgentIssues(response.data.Data))
            }
        }
    } catch (error) {
        console.error(error);
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFilterData().type, getFilterDataAsync),
        takeLatest(getReportData().type, getReportDataAsync),
        takeLatest(createPDF().type, createPDFAsync),
        takeLatest(downloadPDF().type, downloadPDFAsync),
        takeLatest(checkIsNewUser().type, checkIsNewUserAsync),
        takeLatest(getDashboardExcelData().type, downloadDashboardExcelAsync),
        takeLatest(getAccountStatus().type, getAccountStatusAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);